module.exports = __webpack_public_path__ + "static/media/300_8.1be916fd.jpg";